import { cloneDeep } from 'lodash';

import { DBDocObject } from '../../../../generic/db-doc/db-doc-object';
import { DBDocSchema } from '../../../../generic/db-doc/db-doc-schema';
import { OrgConfigNameType } from '../../org-config-name';

export abstract class OrgConfig extends DBDocObject {
  protected type!: OrgConfigNameType;

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DBDocSchema {
    throw new Error('Error: Cannot get schema for abstract OrgConfig');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getType() {
    return cloneDeep(this.type);
  }
}
